<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.list_manager.update_cb_vehicles_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
        :maskClosable="!processing"
        :closable="!processing"
    >
        <p>
            {{ $t('admin.list_manager.update_cb_vehicles_modal.content') }}
        </p>
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="admin-list-manager-update-cb-vehicles"
                :loading="processing"
                @click="handleSubmit"
            >
                {{ $t('admin.list_manager.update_cb_vehicles_modal.submit') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            modal_visible: false,
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
